var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowcolored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 32.458,
    viewBox: "0 0 38 32.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back_arrow_colored_",
    "data-name": "back_arrow(colored)",
    transform: "translate(4892 -10920.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M6,0H32a6,6,0,0,1,6,6V26a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    transform: "translate(-4892 10920.297)",
    fill: "#92ccff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2620",
    "data-name": "Path 2620",
    d: "M4.961,0h21.5a4.961,4.961,0,0,1,4.961,4.961V21.5a4.961,4.961,0,0,1-4.961,4.961H4.961A4.961,4.961,0,0,1,0,21.5V4.961A4.961,4.961,0,0,1,4.961,0Z",
    transform: "translate(-4889 10923.297)",
    fill: "#c0e1fe",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1988",
    "data-name": "Group 1988",
    transform: "translate(-4886 10923.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M26,0H0V26H26Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2613",
    "data-name": "Path 2613",
    d: "M19.5,12H4.5m0,0,6.75,6.75M4.5,12l6.75-6.75",
    transform: "translate(1 1.25)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowcolored);
export default __webpack_public_path__ + "static/media/back_arrow(colored).539b4794ed9a3a92aa988df14f757ae3.svg";
export { ForwardRef as ReactComponent };